import React from 'react';

export default ({ classname }) => (
    <svg className={'icon arrow-right-icon ' + classname} viewBox="0 0 12.5 12">
        <path d="M.648 5.257A.75.75 0 00.75 6.75h9.368l-3.437 4.012-.066.09a.75.75 0 001.204.886l4.498-5.247a.747.747 0 000-.982L7.819.262 7.741.183a.75.75 0 00-1.06 1.055l3.437 4.012H.75z" />
    </svg>
);
